import { render, staticRenderFns } from "./inviteInApp.vue?vue&type=template&id=fc2008f6&scoped=true"
import script from "./inviteInApp.vue?vue&type=script&lang=js"
export * from "./inviteInApp.vue?vue&type=script&lang=js"
import style0 from "./inviteInApp.vue?vue&type=style&index=0&id=fc2008f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2008f6",
  null
  
)

export default component.exports